"use client";

import { Card, CardContent } from "@workspace/ui/components/card";
import { memo } from "react";

interface SpotifyEmbedCardProps {
	/** Spotify artist ID (e.g., "25oLRSUjJk4YHNUsQXk7Ut") */
	spotifyId?: string | null;
	artistName?: string;
}

export const SpotifyEmbedCard = memo<SpotifyEmbedCardProps>(
	({ spotifyId, artistName }) => {
		if (!spotifyId) {
			return null;
		}

		// Construct the artist embed URL with dark theme
		const embedUrl = `https://open.spotify.com/embed/artist/${spotifyId}?utm_source=generator&theme=0`;

		return (
			<Card>
				<CardContent className="p-3">
					<iframe
						data-testid="spotify-artist-embed-iframe"
						style={{ borderRadius: "12px" }}
						src={embedUrl}
						width="100%"
						height="152"
						frameBorder="0"
						allowFullScreen
						allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
						loading="lazy"
						title={
							artistName ? `${artistName} on Spotify` : "Artist on Spotify"
						}
					/>
				</CardContent>
			</Card>
		);
	},
);

SpotifyEmbedCard.displayName = "SpotifyEmbedCard";
